import { useSinglePageQuery } from "~/api/singlePage";
import { Dialog } from "../Dialog";
import { ScrollArea } from "../layout/ScrollArea";
import Button from "~/components/Button";
import Icon from "~/assets/icons/Icon";
import { StrapiOfferLaws } from "~/shared-types";
import { MarkdownReader } from "~/components/MarkdownReader";

export const OfferLawsModal = () => {
  const { data } = useSinglePageQuery<StrapiOfferLaws>("offer-laws");

  return (
    <Dialog
      trigger={
        <a className="text-secondary-600 underline hover:text-secondary-700 cursor-pointer">
          Læs mere
        </a>
      }
      className="grid p-20 pb-8"
      displayIcon
    >
      <ScrollArea>
        <MarkdownReader>{data?.attributes.content}</MarkdownReader>
        <Dialog.Close>
          <Button
            variant="primary-dark"
            size="lg"
            className="mx-auto flex items-center gap-2 mt-8"
          >
            Luk
            <Icon name="close" className="w-6 h-6" />
          </Button>
        </Dialog.Close>
      </ScrollArea>
    </Dialog>
  );
};
